import { render } from "./archives.vue?vue&type=template&id=2e7fc599&scoped=true"
import script from "./archives.vue?vue&type=script&lang=js"
export * from "./archives.vue?vue&type=script&lang=js"

import "./archives.vue?vue&type=style&index=0&id=2e7fc599&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7fc599"]])

export default __exports__